import { render } from "./ConsumptionRoomChart.vue?vue&type=template&id=feb46cb8"
import script from "./ConsumptionRoomChart.vue?vue&type=script&lang=js"
export * from "./ConsumptionRoomChart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tony/argon2/vue-argon-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__